import { REG_EXP_POSITIVE_INTEGER_STRING } from 'shared/entities/regExp/number';
import { ValidatorResult } from 'shared/entities/validator';

import type { SlaPolicyParamsServer } from './server';

/** Границы обоих лимитов из контракта EPIC-24: целые минуты. */
export const SLA_MIN_LIMIT_MINUTES = 1;
export const SLA_MAX_LIMIT_MINUTES = 43200;

export const validateSlaLimitMinutes = (value: string): ValidatorResult => {
  if (!value) {
    return (t) =>
      t('chats.slaSubsection.validation.required', {
        ns: 'projectSettingsPage'
      });
  }

  const numberValue = Number(value);

  if (
    !REG_EXP_POSITIVE_INTEGER_STRING.test(value) ||
    numberValue < SLA_MIN_LIMIT_MINUTES ||
    numberValue > SLA_MAX_LIMIT_MINUTES
  ) {
    return (t) =>
      t('chats.slaSubsection.validation.range', {
        ns: 'projectSettingsPage',
        min: SLA_MIN_LIMIT_MINUTES,
        max: SLA_MAX_LIMIT_MINUTES
      });
  }

  return null;
};

export const areSlaPolicyPayloadsEqual = (
  first: SlaPolicyParamsServer,
  second: SlaPolicyParamsServer
): boolean => {
  return (
    first.enabled === second.enabled &&
    first.first_response_minutes === second.first_response_minutes &&
    first.response_minutes === second.response_minutes
  );
};
